export const IS_INTRO_SEEN_KEY = 'is_intro_seen';
